"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var interfaces_1 = require("@hudled/interfaces");
var react_1 = __importDefault(require("react"));
var formatters_1 = require("utils/formatters");
var LoadingNotification_1 = __importDefault(require("./LoadingNotification"));
var TRANSACTION_TYPE_PLURAL_MAPPER = {
    bankTransaction: 'transactions',
    journalTransactionLineItem: 'journal line items',
};
var getPlural = function (tType) { return TRANSACTION_TYPE_PLURAL_MAPPER[tType] || "".concat((0, formatters_1.camelToLowerProper)(tType), "s"); };
var FetchTransactions = function (_a) {
    var notifications = _a.notifications;
    var notif = notifications[0];
    if (interfaces_1.TRANSACTION_TYPES.every(function (tType) { return notif["".concat(tType, "Count")] === undefined; })) {
        return ((0, jsx_runtime_1.jsxs)(LoadingNotification_1.default, { children: ["We are ", (0, jsx_runtime_1.jsx)("strong", { children: "reading" }), " all your ", (0, jsx_runtime_1.jsx)("strong", { children: "transactions" }), " from ", (0, end2end_1.getNiceProvider)(notif), "."] }));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: ["We have fetched a total of", ' ', interfaces_1.TRANSACTION_TYPES.filter(function (tType) { return notif["".concat(tType, "Count")] !== undefined; })
                .map(function (tType, idx, arr) { return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(0, jsx_runtime_1.jsxs)("strong", { children: [notif["".concat(tType, "Count")], " ", getPlural(tType)] }), (0, end2end_1.getCommaOrAnd)(idx, arr.length)] }, tType)); }), ' ', "from ", notif.provider, "."] }));
};
exports.default = FetchTransactions;
